import dayjs from 'dayjs';
import type {
  SubscriptionRequestHistoryDTO,
  SubscriptionRequestStatus,
} from '../subscriptionRequest.types';
import { FileSimpleModel } from '@repositories/fileRepository/models/FileSimpleModel';
import i18n from '@locales/i18n';

export class SubscriptionRequestHistoryDTOModel {
  private readonly _dto: SubscriptionRequestHistoryDTO;
  private readonly _attachments: FileSimpleModel[] | [];

  constructor(dto: SubscriptionRequestHistoryDTO) {
    this._dto = dto;
    this._attachments = dto.attachments ? dto.attachments.map(attachment => new FileSimpleModel(attachment)) : [];
  }

  get originDTO(): SubscriptionRequestHistoryDTO {
    return this._dto;
  }

  get attachments(): FileSimpleModel[] | [] {
    return this._attachments.sort((a, b) => b.createdDate.diff(a.createdDate));
  }

  get id(): string {
    return this._dto.id || '';
  }

  get comment(): string {
    return this._dto.comment || '';
  }

  get createdDate(): string {
    return this._dto.createdDate ? dayjs(this._dto.createdDate).format('YYYY.MM.DD HH:mm') : '';
  }

  get managerId(): string {
    return this._dto.managerId || '';
  }

  get managerName(): string {
    return this._dto.managerName || '';
  }

  get status(): SubscriptionRequestStatus {
    return this._dto.status || 'APPROVED';
  }

  get subscriptionRequestId(): number {
    return this._dto.subscriptionRequestId || 0;
  }

  get type(): 'MANAGER' | 'STATUS' {
    return this._dto.type || 'MANAGER';
  }

  translateStatus(status: SubscriptionRequestStatus): string {
    switch (status) {
      case 'APPROVED':
        return i18n.t('Subscrib_Detail_BuyRequest_18');
      case 'CANCELLED':
        return i18n.t('Subscrib_Detail_BuyRequest_13');
      case 'DELIVERED':
        return i18n.t('Subscrib_Detail_BuyRequest_17');
      case 'QUOTATION':
        return i18n.t('Subscrib_Detail_BuyRequest_20');
      case 'REJECTED':
        return i18n.t('Subscrib_Detail_BuyRequest_19');
      case 'REQUESTED':
        return i18n.t('Subscrib_Detail_BuyRequest_16');
      default:
        return i18n.t('Subscrib_Detail_BuyRequest_16');
    }
  }

  statusTypeColor(status: SubscriptionRequestStatus): string {
    switch (status) {
      case 'APPROVED':
        return 'pink';
      case 'REJECTED':
        return 'gray';
      case 'REQUESTED':
        return 'blue';
      case 'QUOTATION':
        return 'yellow';
      case 'CANCELLED':
        return 'red';
      case 'DELIVERED':
        return 'green';
      default:
        return 'blue';
    }
  }
}
